import React from 'react';
import Icon from '../../../components/AppIcon';

const DateConfirmation = ({ trailer, startDate, endDate, days }) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-3 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="Calendar" size={20} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <h2 className="font-heading text-2xl font-semibold text-foreground">
          Rental Details
        </h2>
      </div>

      <div className="flex flex-col md:flex-row gap-6">
        <div className="md:w-1/3">
          <img
            src={trailer?.image}
            alt={trailer?.imageAlt}
            className="w-full h-48 object-cover rounded-lg"
          />
        </div>

        <div className="md:w-2/3 space-y-4">
          <div>
            <h3 className="font-heading text-xl font-semibold text-foreground mb-1">
              {trailer?.title}
            </h3>
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="MapPin" size={16} strokeWidth={2} />
              <span className="font-body text-sm">{trailer?.location}</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-border">
            <div>
              <p className="font-caption text-xs text-muted-foreground uppercase mb-1">
                Pick-up Date
              </p>
              <div className="flex items-center space-x-2">
                <Icon name="CalendarCheck" size={18} color="var(--color-success)" strokeWidth={2} />
                <p className="font-body text-base font-medium text-foreground">
                  {formatDate(startDate)}
                </p>
              </div>
            </div>

            <div>
              <p className="font-caption text-xs text-muted-foreground uppercase mb-1">
                Return Date
              </p>
              <div className="flex items-center space-x-2">
                <Icon name="CalendarCheck" size={18} color="var(--color-success)" strokeWidth={2} />
                <p className="font-body text-base font-medium text-foreground">
                  {formatDate(endDate)}
                </p>
              </div>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <div className="flex items-center justify-between">
              <span className="font-body text-base text-muted-foreground">
                Total Rental Duration
              </span>
              <span className="font-heading text-lg font-semibold text-primary">
                {days} {days === 1 ? 'Day' : 'Days'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateConfirmation;